import React from "react";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { CursorPointer } from "../../../CursorPointer/CursorPointer";
import { WeightMedium } from "../../../WeightMedium/WeightMedium";
import { FrontIcon } from "../FrontIcon/FrontIcon";
import FrontParagraphSmall from "../FrontParagraphSmall/FrontParagraphSmall";

type TCheckboxProps = {
    isSelected: boolean;
    label: string;
    onClick: () => void;
};

export const FrontCheckboxWithLabel = (props: React.PropsWithChildren<TCheckboxProps>): JSX.Element => {

    return (
        <CursorPointer onClick={props.onClick}>
            <SpacingRow spacing={FrontSpacing.SMALL_2}>
                <FrontIcon
                    iconName={props.isSelected ? "checkbox-checked" : "checkbox-unchecked"}
                    colour="neutral-0"
                />
                <FrontParagraphSmall>
                    <WeightMedium>
                        {props.label}
                    </WeightMedium>
                </FrontParagraphSmall>
            </SpacingRow>
        </CursorPointer>
    );
};
